import { ReactElement, useMemo } from 'react';
import { PlanEntitlementKey } from '../../api/graphql/generated';
import { useCurrentUser } from '../../api/user.hooks';
import { useHasEntitlement } from '../plan/plan-entitlement-hooks';
import { Paywall } from './paywall';

interface PaywallWrapperProps {
  children: ReactElement;
  planEntitlementKey: PlanEntitlementKey;
  isFeatureAvailable?: (hasEntitlement: boolean) => boolean;
}

export const PaywallWrapper = (props: PaywallWrapperProps): ReactElement => {
  const { children, planEntitlementKey, isFeatureAvailable } = props;
  const user = useCurrentUser();
  const hasEntitlement = useHasEntitlement(planEntitlementKey);

  const isAvailable = useMemo(() => {
    return isFeatureAvailable
      ? isFeatureAvailable(hasEntitlement)
      : hasEntitlement;
  }, [isFeatureAvailable, hasEntitlement]);

  if (user === undefined) {
    return <></>;
  }

  return (
    <>
      {!isAvailable ? (
        <Paywall user={user} planEntitlementKey={planEntitlementKey} />
      ) : (
        children
      )}
    </>
  );
};
